"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConfigsClient = exports.getContextValidated = exports.setContext = void 0;
const config_result_1 = require("../generated/cdp/cof/config_result");
const evaluator_1 = require("../targeting_evaluation/evaluator");
const grpcWeb_1 = require("./grpcWeb");
// key to store library context on window object
const CONTEXT_KEY = Symbol("context key");
// default settings
const DEFAULT_SETTINGS = {
    host: "https://aws.api.snapchat.com",
};
// store settings on a global object to avoid issues,
// when for some reason this modules is loaded more than once
if (typeof window !== "undefined") {
    Object.defineProperty(window, CONTEXT_KEY, {
        enumerable: false,
        writable: true,
    });
}
/**
 * Stores settings in globally.
 * @internal
 */
function setContext(settings) {
    if (typeof window !== "undefined") {
        window[CONTEXT_KEY] = settings;
    }
}
exports.setContext = setContext;
/**
 * Reads previously stored settings.
 */
function getContext() {
    if (typeof window !== "undefined") {
        return window[CONTEXT_KEY];
    }
}
/**
 * Returns settings object previously initialized with initConfigsClient().
 * @internal
 */
function getContextValidated() {
    const context = getContext();
    if (!context) {
        throw new Error("initConfigsClient() has to be called on app startup");
    }
    return context;
}
exports.getContextValidated = getContextValidated;
/**
 * Initializes COF configs client.
 * The function has to be called once on app startup.
 */
function initConfigsClient(initSettings) {
    const settings = Object.assign(Object.assign({}, DEFAULT_SETTINGS), initSettings);
    const existingContext = getContext();
    if (existingContext) {
        // there is a chance that bundlers include initConfigsClient() into different chunks,
        // we are good if the same settigs object is passed,
        // otherwise throw an error;
        // JSON.stringify approach is simple and good to catch exactly that issue:
        // the same settings objects are created in the same way in different chunks
        if (JSON.stringify(settings) !== JSON.stringify(existingContext.settings)) {
            throw new Error("initConfigsClient() has already been called");
        }
    }
    else {
        setContext({
            settings: settings,
            rpc: new grpcWeb_1.GrpcWebImpl(settings.host, {
                metadata: settings.metadata,
                transport: settings.transport,
                debug: settings.debug
            }),
        });
        // Add default providers for browser height and width. Can be overrided by re-registering these properties.
        evaluator_1.registerPropertyValueProvider(config_result_1.ClientTargetingExpression_Property.WEB_SCREEN_HEIGHT, () => window.innerHeight);
        evaluator_1.registerPropertyValueProvider(config_result_1.ClientTargetingExpression_Property.WEB_SCREEN_WIDTH, () => window.innerWidth);
    }
}
exports.initConfigsClient = initConfigsClient;
//# sourceMappingURL=initConfigsClient.js.map